import React, {Component} from 'react';
import {
    ActivityIndicator,
    AlertModal,
    CCText,
    View
} from "../../../custom-packages/react-native-components-in-react/react-native-components-in-react";
import Styles from "../../../Styles";
import AppConfig from "../../../AppConfig";
import DefaultButton, {BorderlessButton} from "../../../custom-packages/react-button-package/ButtonPackage";
import TRestaurantTableItem from "./Translations/TRestaurantTableItem";
import ToggleOnIcon from "../../../assets/custom-icons/ToggleOnIcon";
import ToggleOffIcon from "../../../assets/custom-icons/ToggleOffIcon";


export default class RestaurantTableItem extends Component {

    constructor(props) {
        super(props);

        this.state = {
            table: this.props.item,
            toggleLoading: false,
            isQrModalOpen: false,
            deleted: false,
            alertState: {
                alertVisible: false,
                alertTitle: '',
                alertText: '',
                alertButtons: []
            }
        };
    }

    componentDidMount() {

    }

    componentWillUnmount() {

    }

    render() {
        if (this.state.deleted) {
            return null;
        }

        return <View style={{ marginTop: 15 }}>
            <View style={{...Styles.flexDirectionRow, justifyContent: 'space-between', alignItems: 'center'}}>
                <CCText style={{fontSize: 20, fontWeight: 'bold'}}>
                    {TRestaurantTableItem[AppConfig.lang].TABLE + ' ' + this.state.table.rtA_TABLE_NUMBER}
                </CCText>
                <View style={{justifyContent: 'flex-end', ...Styles.flexDirectionRow}}>
                    <DefaultButton
                        loading={this.state.toggleLoading}
                        icon={this.state.table.rtA_ACTIVE ? <ToggleOnIcon size={25} /> : <ToggleOffIcon size={25} />}
                        text={this.state.table.rtA_ACTIVE ? TRestaurantTableItem[AppConfig.lang].ENABLED : TRestaurantTableItem[AppConfig.lang].DISABLED}
                        onPress={this.ToggleRestaurantTable.bind(this, this.state.table)}
                    />
                    {this.state.table.rtA_ACTIVE ?
                        null
                        :
                        this.state.deleting ?
                            <View style={{...Styles.flexDirectionRow}}>
                                <View style={{width: 7}}></View>
                                <ActivityIndicator size={30}/>
                            </View>
                            :
                            <View style={{...Styles.flexDirectionRow}}>
                                <View style={{width: 7}}></View>
                                <BorderlessButton
                                    textStyle={{...Styles.redColor}}
                                    text={TRestaurantTableItem[AppConfig.lang].DELETE}
                                    onPress={this.DeleteRestaurantTable.bind(this)}
                                />
                            </View>
                    }
                </View>
            </View>
            <AlertModal
                visible={this.state.alertState.alertVisible}
                onRequestClose={() => this.setState({
                    alertState: {
                        ...this.state.alertState,
                        alertVisible: !this.state.alertState.alertVisible
                    }
                })}
                title={this.state.alertState.alertTitle}
                text={this.state.alertState.alertText}
                buttons={this.state.alertState.alertButtons}
            />
        </View>;
    }

    async ToggleRestaurantTable() {
        const table = {...this.state.table};

        table.rtA_ACTIVE = !table.rtA_ACTIVE;

        this.setState({
            toggleLoading: true,
            table: table
        });

        const response = await fetch(AppConfig.URL + "/Restaurant/ToggleRestaurantTable/?RestaurantTableID=" + this.state.table.rtA_ID, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': this.props.Auth.token
            }
        });

        const r = await response.json();

        if (r.success) {
            this.setState({
                toggleLoading: false,
            });
        }
    }

    async DeleteRestaurantTable() {
        this.setState({
            alertState: {
                alertTitle: TRestaurantTableItem[AppConfig.lang].DELETE_RESTAURANT_TABLE_TITLE,
                alertText: TRestaurantTableItem[AppConfig.lang].DELETE_RESTAURANT_TABLE_TEXT,
                alertButtons: [
                    {
                        text: TRestaurantTableItem[AppConfig.lang].CANCEL,
                        onPress: () => {
                        },
                        style: "cancel"
                    },
                    {
                        text: TRestaurantTableItem[AppConfig.lang].CONFIRM_DELETE_RESTAURANT_TABLE_TEXT,
                        onPress: async () => {
                            this.setState({
                                deleting: true,
                            })

                            const response = await fetch(AppConfig.URL + "/Restaurant/DeleteRestaurantTable/?RestaurantTableID=" + this.state.table.rtA_ID, {
                                method: 'GET',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json',
                                    'Authorization': this.props.Auth.token
                                }
                            });

                            const r = await response.json();

                            if (r.success) {
                                this.setState({
                                    deleting: false,
                                    deleted: true
                                });

                                this.props.deleteCallback(this.state.table)
                            }
                        }
                    }
                ],
                alertVisible: !this.state.alertState.alertVisible
            }
        })
    }
}